import React from "react"
import {FieldViewSmallProps} from "../../render/view-small";

export default function FieldProto_ViewSmall(props: FieldViewSmallProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    return (
        <div className="ui5-txt-less-important-small">{props.field.getDisplayValue(value)}</div>
    )

}